import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import React from 'react';
import { ChildrenColumnType } from '../children-compilation-extended.model';
import { EntryNumberDataGridCell } from './EntryNumberDataGridCell';
import { UseEditEntryNumberOutput } from '../inline-edit/entry-number/use-edit-entry-number';

export function EntryNumberColumnDataGrid<T extends ChildrenColumnType>(
	editEntryNumber: UseEditEntryNumberOutput | null,
): GridColDef<T, T> {
	return {
		headerName: 'Entry Number',
		field: 'entryNumber',
		width: 150,
		editable: false, // Disable MUI's edit mode since we handle it ourselves
		renderCell: (params: GridRenderCellParams<T, T>) => (
			<EntryNumberDataGridCell params={params} editEntryNumber={editEntryNumber} />
		),
	};
}

export function EntryClassColumnDataGrid<T extends ChildrenColumnType>(): GridColDef<T, string> {
	return {
		headerName: 'Entry Class',
		field: 'entryClass',
		renderCell: (params) => params.value,
		editable: false,
		width: 150,
	};
}
